import InteractionBase from '../InteractionBase';
import { XylophoneTable } from './display/XylophoneTable';
import { XylophoneBubbles } from './display/XylophoneBubbles';
import { StateXylophoneSongSelect } from './states/StateXylophoneSongSelect';
import { StateXylophoneSongPlay } from './states/StateXylophoneSongPlay';
import { StateXylophoneSongComplete } from './states/StateXylophoneSongComplete';
import { Xylophone } from './display/Xylophone';
import { StateXylophoneSongIntro } from './states/StateXylophoneSongIntro';
import ScenarioCharacter from '../../display/ScenarioCharacter';
import { HUMALONG_SONGS } from './config/config';
import { TRACK_EVENTS } from 'game/tracking/stats.js';
const assetpack = require('../../../../assets/assetpack_humalong.json');

export default class InteractionHumAlong extends InteractionBase {
  constructor(properties) {
    super('humalong');
  }

  init({ tracking = {} }) {
    this.tracking = tracking;
  }

  preload() {
    this.game.loader.loadAssetPack(
      assetpack,
      Object.keys(assetpack),
      this.handleLoadComplete.bind(this)
    );
  }

  handleLoadComplete() {
    this.add.rectangle(910, 390, 1820, 780, 0x87cdeb);
    this.game.soundController.stopMusic();

    this.selectedSong = 'twinkletwinkle';

    this.character = new ScenarioCharacter(this, {
      x: 910,
      y: 1100,
      id: 'big_bird',
      ignoreSFX: ['b-bird_legs'],
    });
    this.character.play('nervous', true);
    this.xylophoneBubbles = new XylophoneBubbles(this);
    this.table = new XylophoneTable(this, 910, 250);
    this.xylophone = new Xylophone({ scene: this, position: { x: 940, y: 155 }, scale: 0.7 });
    this.xylophone.setPosition(940, 155);

    this._stateSongSelect = new StateXylophoneSongSelect(this, HUMALONG_SONGS);
    this._StateXylophoneSongIntro = new StateXylophoneSongIntro(this);
    this._stateSongPlay = new StateXylophoneSongPlay(this, {
      character: this.character,
      xylophone: this.xylophone,
      xylophoneBubbles: this.xylophoneBubbles,
    });
    this._stateSongComplete = new StateXylophoneSongComplete(this, { character: this.character });

    this._stateSongSelect.on('song_select', this.handleSongSelected, this);
    this._StateXylophoneSongIntro.on('state_complete', this.nextState, this);
    this._stateSongPlay.on('state_complete', this.nextState, this);
    this._stateSongComplete.on('state_complete', this.nextState, this);

    this._stateOrder = [
      this._stateSongSelect,
      this._StateXylophoneSongIntro,
      this._stateSongPlay,
      this._stateSongComplete,
    ];
    this._stateIndex = -1;
    this.displayState = 'select';

    this.startStateByIndex(0);
    // this.handleSongSelected('twinkletwinkle');
  }

  nextState() {
    if (this._stateIndex == this._stateOrder.length - 1) this.endScenario();
    else this.startStateByIndex(this._stateIndex + 1);
  }

  startStateByIndex(index) {
    this.setState(this._stateOrder[Phaser.Math.Clamp(index, 0, this._stateOrder.length - 1)]);
  }

  setState(state) {
    this._stateIndex = this._stateOrder.indexOf(state);
    switch (state) {
      case this._stateSongPlay:
        this.stateMachine.setState(this._stateSongPlay, {
          id: this.selectedSong,
          data: this.createSelectedSongData(this.selectedSong),
        });
        break;
      default:
        this.stateMachine.setState(state);
        break;
    }
  }

  handleSongSelected(songid) {
    this.selectedSong = songid;
    const songTrackingNames = {
      oldmacdonald: 'Old McDonald',
      twinkletwinkle: 'Twinkle Twinkle',
      rowrowboat: 'Row Row Boat',
    };
    const buttonName = songTrackingNames[songid];
    this.game.stats.track(TRACK_EVENTS.GAME_MENU_CLICK, { buttonName });
    this.game.stats.setScreenName(this.tracking.INTERACTION2);
    this.nextState();
  }

  update(time, delta) {
    this.xylophoneBubbles?.updateBubbles(delta);
  }

  handleSongComplete() {
    this.setState(this._stateSongComplete);
  }

  setDisplayType(type, options = {}) {
    const { onComplete, onCompleteScope } = options;

    if (this.displayState == type) {
      if (onComplete) {
        this.time.addEvent({
          delay: 1000,
          callback: onComplete,
          callbackScope: onCompleteScope,
        });
      }
      return;
    }

    this.displayState = type;
    this.tweens.add({
      targets: this.table,
      y: type === 'select' ? 250 : 1050,
      duration: 750,
    });
    this.tweens.add({
      targets: this.xylophone,
      y: type === 'select' ? 155 : 675,
      scale: type === 'select' ? 0.7 : 0.5,
      duration: 750,
      onComplete: () => (onComplete ? onComplete.apply(onCompleteScope) : false),
      completeDelay: 1000,
    });
    this.game.soundController.playSFX('sfx', 'sfx_ui_whoosh');
    this.character.visible = type === 'select' ? false : true;
  }

  endScenario() {
    this.endInteraction();
  }

  createSelectedSongData(songid) {
    let songscsv = this.cache.text.get(`humalong_${songid}`).replaceAll('\r', '').split('\n');
    songscsv = songscsv.map((line) => line.split(','));
    const song = [];
    for (let i = 1; i < songscsv.length; i++) {
      song.push({ time: parseFloat(songscsv[i][0]), notes: [songscsv[i][1]] });
    }
    return song;
  }
}
